import { render, staticRenderFns } from "./VersionImportLogDataGrid.vue?vue&type=template&id=52f97b72&scoped=true&"
import script from "./VersionImportLogDataGrid.vue?vue&type=script&lang=js&"
export * from "./VersionImportLogDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./VersionImportLogDataGrid.vue?vue&type=style&index=0&id=52f97b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f97b72",
  null
  
)

export default component.exports